import React from 'react';
import { useParams } from 'react-router-dom';

import { Container, Box } from '@mui/material';
import { API_ENDPOINT } from '../../../configurations/global.config';
import CreateCustomerForm from '../create-customer-form/create-customer-form';

function Customer() {
  const { customerId } = useParams();
  return (
    <div>
      <Container>
        <Box>
          <CreateCustomerForm
            defaultCustomerId={customerId}
          />
        </Box>
      </Container>
    </div>
  );
}

export default Customer;
